export default __webpack_public_path__ + "static/media/Countdown_5.f0cfaf32.png";